/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment';
import { useEffect, useState } from 'react';
import classes from './calender.module.scss'
import Checkbox from '@mui/material/Checkbox';
import cx from "classnames";
import { CalendarSvg } from '../constants/resources';
const Calender = (props: any) => {

    const { node, data, change, selectionRange, setDayFlex, dayFlex, toggleHover, setToggleHover } = props;
    const [flexData, setFlexData] = useState(0)
    const updateCount = (node: any, value: any) => {

        let updateData = [...data];
        let filter: any;
        filter = updateData.filter((n: any) => {
            return n.name === 'tripDateFelxibility';
        });
        if (value >= 0 && value <= 5) {
            setFlexData(value)
            if (filter[0]) {
                filter[0].value = value

                change([...updateData])
            }
        }


    }
    useEffect(() => {
        if (dayFlex) {
            updateCount(node, 1)
        } else {
            updateCount(node, 0)
        }



    }, [dayFlex])

    return (
        <div className={classes.textGroup}>

            <div style={{ marginTop: "10px", marginBottom: "20px", position: 'relative' }}>
                <div className={classes.textDate}>
                    <div>
                        {node.name === 'startDate' && selectionRange?.startDate ? <div className={classes.displaydate} onClick={() => setToggleHover(!toggleHover)}>
                            <div className={classes.date}>
                                {moment.utc(selectionRange.startDate).format('DD')}
                                <div className={classes.week}>
                                    {moment.utc(selectionRange.startDate).format('dddd')}

                                    <div className={classes.year}>
                                        {moment.utc(selectionRange.startDate).format('MMM YYYY')}
                                    </div>
                                </div>
                            </div>
                        </div> : node.name === 'endDate' && selectionRange?.endDate ? <div className={classes.displaydate} onClick={() => setToggleHover(!toggleHover)}>
                            <div className={classes.date}>
                                {moment.utc(selectionRange.endDate).format('DD')}
                                <div className={classes.week}>
                                    {moment.utc(selectionRange.endDate).format('dddd')}

                                    <div className={classes.year}>
                                        {moment.utc(selectionRange.endDate).format('MMM YYYY')}
                                    </div>
                                </div>
                            </div>
                        </div> :
                            <div className={classes.displaydate} onClick={() => setToggleHover(!toggleHover)}>
                                <div className={classes.date}>
                                    <CalendarSvg width={"24"} height={"24"} color={"#0094FF"} />
                                    <div className={classes.week}>
                                        {node.title}

                                        <div className={classes.year}>
                                            {node.placeholder}
                                        </div>
                                    </div>
                                </div>
                            </div>}
                        <div className={classes.flexibilty}>
                            <div>
                                <Checkbox className={classes.name} id={"+ - 3 Days"} name={"+ - 3 Days"} value={3} onChange={() => { setDayFlex(!dayFlex); }} />
                                <label className={classes.name}> My dates are flexible</label>
                            </div>


                            <div>{dayFlex ?

                                <div className={classes.actionbox}>

                                    <div className={flexData <= 0 ? cx(classes.actButton, classes.disabled) : classes.actButton} onClick={() => updateCount(node, flexData - 1)}><div className={classes.sub}>-</div></div>
                                    <div className={classes.actCount}><div className={classes.count}>{flexData} Day{flexData > 1 ? 's' : ''}</div></div>
                                    <div className={flexData >= 5 ? cx(classes.actButton, classes.disabled) : classes.actButton} onClick={() => updateCount(node, flexData + 1)}><div className={classes.sub}>+</div></div>
                                </div>
                                : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}


export default Calender